module.exports = __webpack_public_path__ + "img/theme-banner.0780f8ea.png";